/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * @example
 *     {
 *         issuer: "issuer",
 *         validFrom: undefined,
 *         validUntil: undefined
 *     }
 */
export interface DraftExportRequest {
    /** The URI of the credential issuer. */
    issuer: string;
    /** The date and time the issued credential is valid from. */
    validFrom?: Date;
    /** The date and time the issued credential is valid until. */
    validUntil?: Date;
}
